import keyBy from 'lodash/keyBy';
import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';
import { fetchVendors, linkSubscriptionToVendor, unLinkSubscriptionToVendor } from '../feedback-linking.utils';

export default {
    namespaced: true,
    state: {
        map: {},
        error: {},
        fetching: false,
        linkingError: {},
        linking: false,
        unLinkingError: {},
        unLinking: false,
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setError (state, { error }) {
            state.error = error;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
        setLinking (state, { linking }) {
            state.linking = linking;
        },
        setLinkingError (state, { linkingError }) {
            state.linkingError = linkingError;
        },
        setUnLinking (state, { unLinking }) {
            state.unLinking = unLinking;
        },
        setUnLinkingError (state, { unLinkingError }) {
            state.unLinkingError = unLinkingError;
        },
    },
    actions: {
        loadAll ({ commit, state }, { reFetch = false } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return Promise.resolve();
            }

            commit('setFetching', { fetching: true });

            return fetchVendors()
                .then(({ data: vendors }) => {
                    commit('setFetching', { fetching: false });
                    commit('setMap', {
                        map: keyBy(vendors, 'uuid'),
                    });
                })
                .catch((error) => {
                    commit('setFetching', { fetching: false });
                    commit('setError', { error });
                    throw error;
                });
        },
        linkVendor ({ commit }, { vendorUuid } = {}) {
            commit('setLinking', { linking: true });
            if (!vendorUuid) {
                throw new Error('No VendorId Given');
            }

            return linkSubscriptionToVendor({ vendorUuid })
                .then(() => {
                    commit('setLinking', {
                        linking: false,
                    });
                })
                .catch((linkingError) => {
                    commit('setLinking', {
                        linking: false,
                    });
                    commit('setLinkingError', { linkingError });
                    throw linkingError;
                });
        },
        unLinkVendor ({ commit }) {
            commit('setUnLinking', { unLinking: true });

            return unLinkSubscriptionToVendor()
                .then(() => {
                    commit('setUnLinking', {
                        unLinking: false,
                    });
                })
                .catch((unLinkingError) => {
                    commit('setUnLinking', {
                        unLinking: false,
                    });
                    commit('setUnLinkingError', { unLinkingError });
                    throw unLinkingError;
                });
        },
    },
    getters: {
        unLinkedVendorsList: (state) => values(state.map).filter((vendor) => !vendor.pendo_subscription_id),
        vendorByUuid: (state) => (uuid) => state.map[uuid],
    },
};
